import { Map, Feature } from 'ol';
import GeometryType from 'ol/geom/GeometryType';
import { INode, FeatureType, ICAMSKey, IMapInteractionConfig, IAPIResult, TextPack } from '../Shared/Models/UtilityModels';
import * as toastr from "toastr";
import { Utilities, ModalAction, ITextPackModel } from '../Shared/Utility/Utilities';
import * as events from '../Shared/Bus/Bus';
import { WKT } from 'ol/format';
import { AnnotationFilter, AnnotationOrder, IAnnotationStyleModel } from './AnnotationModels';
import { IFilterDefinitionModel } from '../Shared/Models/FilteringModel';
import { LocalStorageSettingsModel } from '../Shared/Models/LocalStorageSettingsModel';
import { ModalPrompts, PredefinedModalEnum } from '../Shared/Utility/ModalPrompts';

// List of Jquery controls used in this class
enum jqc {
    placeholder_for_modals = '#placeholder-for-modals',
    placeholder_for_legalmodals = '#placeholder-for-legalmodals',
    rightSelectGroupPanel = '#rightSelectGroupPanel',

    annotationsPanel = '#annotationsPanel',
    annotationsListContainer = '#annotationsListContainer',
    annotationsRecordFilter = '#annotationsRecordFilter',
    annotationsListTable = '#annotationsListTable',
    annotationsSelectedView_TitleCount = '#annotationsSelectedView_TitleCount',
    annotationsListShowingStartBtn = '#annotationsListShowingStartBtn',
    annotationsListShowingPrevBtn = '#annotationsListShowingPrevBtn',
    annotationsListShowing = '#annotationsListShowing',
    annotationsListShowingNextBtn = '#annotationsListShowingNextBtn',
    annotationsListShowingEndBtn = '#annotationsListShowingEndBtn',
    annotationsListPageAmount = '#annotationsListPageAmount',
    annotationsListMapBtn = '#annotationsListMapBtn',
    annotationsListPrintBtn = '#annotationsListPrintBtn',
    annotationsListNewBtn = '#annotationsListNewBtn',
    annotationsListEditBtn = '#annotationsListEditBtn',
    annotationsListMoveBtn = '#annotationsListMoveBtn',
    annotationsListDeleteBtn = '#annotationsListDeleteBtn',
    annotationsListCloseBtn = '#annotationsListCloseBtn',
    annotationEditModal = '#annotationEditModal',
    annotationEditCloseBtn = '#annotationEditCloseBtn',
    annotationEditForm = '#annotationEditForm',
    annotationEditCancelBtn = '#annotationEditCancelBtn',
    annotationEditSubmitBtn = '#annotationEditSubmitBtn',
    annotationCreateModal = '#annotationCreateModal',
    annotationCreateCloseBtn = '#annotationCreateCloseBtn',
    annotationCreateForm = '#annotationCreateForm',
    annotationCreateCancelBtn = '#annotationCreateCancelBtn',
    annotationCreateSubmitBtn = '#annotationCreateSubmitBtn',
    annotationToolContainer = '#annotationToolContainer',
    annotationToolCloseBtn = '#annotationToolCloseBtn',
    annotationToolPanel = '#annotationToolPanel',
    annotationToolTopBar = '#annotationToolTopBar',
    annotationToolTitle = '#annotationToolTitle',
    annotationsToolCreateSelectBtn = '#annotationsToolCreateSelectBtn',
    annotationsToolCreateTextBtn = '#annotationsToolCreateTextBtn',
    annotationsToolCreatePointBtn = '#annotationsToolCreatePointBtn',
    annotationsToolCreateLineBtn = '#annotationsToolCreateLineBtn',
    annotationsToolCreatePolygonBtn = '#annotationsToolCreatePolygonBtn',
    annotationsToolCreateRectangleBtn = '#annotationsToolCreateRectangleBtn',
    annotationToolMainTools = '#annotationToolMainTools',
    annotationToolCreateWizard = '#annotationToolCreateWizard',
    annotationToolCreateWizard_SelectMessage1 = '#annotationToolCreateWizard_SelectMessage1',
    annotationToolCreateWizard_SelectMessage2 = '#annotationToolCreateWizard_SelectMessage2',
    annotationToolCreateWizard_Message1 = '#annotationToolCreateWizard_Message1',
    annotationToolCreateWizard_Message2 = '#annotationToolCreateWizard_Message2',
    annotationToolCreateWizard_EditForm = '#annotationToolCreateWizard_EditForm',
    annotationToolCreateWizard_CancelBtn = '#annotationToolCreateWizard_CancelBtn',
    annotationToolCreateWizard_SaveBtn = '#annotationToolCreateWizard_SaveBtn',
    annotationToolCreateWizard_DeleteBtn = '#annotationToolCreateWizard_DeleteBtn',
    annotationEditGeomModal = '#annotationEditGeomModal',
    annotationEditGeomCloseBtn = '#annotationEditGeomCloseBtn',
    annotationEditGeomForm = '#annotationEditGeomForm',
    annotationEditGeomCancelBtn = '#annotationEditGeomCancelBtn',
    annotationEditGeomSubmitBtn = '#annotationEditGeomSubmitBtn',
    annotationSelectListModal = '#annotationSelectListModal',
    annotationSelectListCloseBtn = '#annotationSelectListCloseBtn',
    annotationSelectListCancelBtn = '#annotationSelectListCancelBtn',
    annotationSelectListShowBtn = '#annotationSelectListShowBtn',
    annotationSelectListCreateBtn = '#annotationSelectListCreateBtn',
    annotationSelectListDeleteBtn = '#annotationSelectListDeleteBtn',
    annotationsSelectListTable = '#annotationsSelectListTable',
    annotationsNewBtn = '#annotationsNewBtn',
    newAnnotationPanel = '#newAnnotationPanel',
    newAnnotationCloseBtn = '#newAnnotationCloseBtn',
    newAnnotation_CancelBtn = '#newAnnotation_CancelBtn',
    annotationRightSelectPanel = '#annotationRightSelectPanel',
    annotationRightSelectPanelMessage = '#annotationRightSelectPanelMessage',
    annotationRightSelectPanel_EditBtn = '#annotationRightSelectPanel_EditBtn',
    annotationRightSelectPanel_ClearBtn = '#annotationRightSelectPanel_ClearBtn',
    annotationRightSelectPanel_MapBtn = '#annotationRightSelectPanel_MapBtn',
    annotationRightSelectPanel_ListBtn = '#annotationRightSelectPanel_ListBtn'
}

export class Annotations {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private issueMaxNumberInList: number = 10;
    private issueCountFromServer: number = 0;
    private currentPage: number = 0;
    private newAnnotationWizardState: { drawFeature?: Feature, selectedFeature_AnnotationGeomID?: number };
    private subscriptionSingleFeatureSelected;
    private subscriptionDrawCompleted;
    private subscriptionMapGeometrySaved;
    private annotationToolbar_CurrentAnnotationUID: number;
    private annotationToolbar_CurrentAnnotationWKT: string;
    private annotationToolbar_CreateType: string;

    // List of buttions in the action toolbar
    private actionBtns = {
        print: { btn: $(jqc.annotationsListPrintBtn + ' button'), enable: false },
        new: { btn: $(jqc.annotationsListNewBtn + ' button'), enable: false },
        edit: { btn: $(jqc.annotationsListEditBtn + ' button'), enable: false },
        delete: { btn: $(jqc.annotationsListDeleteBtn + ' button'), enable: false }
    };

    private toolbarBtns = {
        select: { btn: $(jqc.annotationsToolCreateSelectBtn + ' button'), enable: false },
        createtext: { btn: $(jqc.annotationsToolCreateTextBtn + ' button'), enable: false },
        createpoint: { btn: $(jqc.annotationsToolCreatePointBtn + ' button'), enable: false },
        createline: { btn: $(jqc.annotationsToolCreateLineBtn + ' button'), enable: false },
        createpoly: { btn: $(jqc.annotationsToolCreatePolygonBtn + ' button'), enable: false },
        createrect: { btn: $(jqc.annotationsToolCreateRectangleBtn + ' button'), enable: false },
    };

    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;

        // Set default style
        var style = self.getLocalStyleDetails();
        if (style == null) {
            style = {};
            style.text = { fillColorHex: "#000000", font: "Arial", size: 16, weight: "Normal" };
            style.stroke = { colorHex: "#000000", endCap: "arrow", width: 2 };
            style.fill = { colorHex: "#FFAAAA" };
            self.setLocalStyleDetails(style);
        }

        // ANNOTATIONS
        Utilities.GetControl(jqc.annotationsListCloseBtn).on('click', function () { Utilities.GetControl(jqc.annotationsPanel).removeClass('show'); });

        self.actionBtns.print.btn.on("click", function () {
            toastr.info("To be confirmed");
        });
        self.actionBtns.new.btn.on("click", function () {
            Utilities.GetControl(jqc.annotationsPanel).removeClass('show');
            setTimeout(function () { self.openCreateAnnotationGroupPanel(null); }, 300);
        });
        self.actionBtns.edit.btn.on("click", function () {
            var table: any = Utilities.GetControl(jqc.annotationsListTable)
            let rows = table.bootstrapTable('getSelections');
            self.openEditAnnotationGroupPanel(rows[0].UID as number);
        });
        self.actionBtns.delete.btn.on("click", function () {
            var table: any = Utilities.GetControl(jqc.annotationsListTable)
            let rows = table.bootstrapTable('getSelections');
            self.DeleteAnnotationFromServer(rows[0].UID as number);
        });

        // FILTERS
        self.setupAnnotationListFilters();
        Utilities.GetControl(jqc.annotationsRecordFilter).on('change', function () { self.resetPage(); self.GetAnnotationData(); });

        // PAGING BTNS
        Utilities.GetControl(jqc.annotationsListPageAmount).on('change', function () {
            self.issueMaxNumberInList = $(jqc.annotationsListPageAmount + 'select').children("option:selected").val() as number;
            self.GetAnnotationData();
        });
        Utilities.GetControl(jqc.annotationsListShowingStartBtn).on("click", function () {
            self.currentPage = 0;
            this.blur();
            self.GetAnnotationData();
        });
        Utilities.GetControl(jqc.annotationsListShowingEndBtn).on("click", function () {
            self.currentPage = Math.trunc(self.issueCountFromServer / self.issueMaxNumberInList);
            this.blur();
            self.GetAnnotationData();
        });
        Utilities.GetControl(jqc.annotationsListShowingNextBtn).on("click", function () {
            if (self.currentPage == Math.trunc(self.issueCountFromServer / self.issueMaxNumberInList)) return;

            self.currentPage++;
            this.blur();
            self.GetAnnotationData();
        });
        Utilities.GetControl(jqc.annotationsListShowingPrevBtn).on("click", function () {
            if (self.currentPage == 0) return;
            self.currentPage--;
            this.blur();
            self.GetAnnotationData();
        });

        // Initialize table
        var table: any = Utilities.GetControl(jqc.annotationsListTable)
        if (table != null && table.bootstrapTable) {
            table.bootstrapTable();

            table.on('check.bs.table', function (e, row, $element) {
                self.checkVisibleButtons();
                self.SetCurrentAnnotation(row.UID, row.Title, row.WKT, false, false);
            });
            table.on('check-all.bs.table', function (e, rowsAfter, rowsBefore) {
                self.checkVisibleButtons();
            });
            table.on('uncheck.bs.table', function (e, row, $element) {
                table.bootstrapTable('checkBy', { field: 'UID', values: [row.UID] }); // This stops the table ever unselecting the record 
            });
            table.on('uncheck-all.bs.table', function (e, rowsAfter, rowsBefore) {
                self.checkVisibleButtons();
            });
            table.on('click-cell.bs.table', function (e, field, value, row, $element) {
                if (field == "AnnotationCount") {
                    events.bus.publish(events.eventZoomToWKTandHighlight([[row.WKT], true, false, FeatureType.Annotation]));
                }
            });
        }

        // ****************************************************
        // WIZARD BUTTONS
        Utilities.GetControl(jqc.newAnnotationCloseBtn).on("click", self.newMaintWizard_Close);
        Utilities.GetControl(jqc.newAnnotation_CancelBtn).on("click", self.newMaintWizard_Close);

        // ****************************************************
        // TOOLBAR
        Utilities.GetControl(jqc.annotationToolCloseBtn).on('click', function () {
            self.CloseAnnotationToolbar();
        });

        // ****************************************************
        // Right hand select group panel 
        Utilities.GetControl(jqc.annotationRightSelectPanel_EditBtn).on('click', function () {
            if (Utilities.GetControl(jqc.annotationToolContainer).is(':visible') == true) {
                Utilities.GetControl(jqc.annotationRightSelectPanel_EditBtn).css('color', 'white');
                self.CloseAnnotationToolbar();
            }
            else {
                Utilities.GetControl(jqc.annotationRightSelectPanel_EditBtn).css('color', 'lightgreen');
                Utilities.GetControl(jqc.annotationToolContainer).show();
                // This will automatically start the select process
                self.newAnnotationWizard_SelectStart();
            }
        });
        Utilities.GetControl(jqc.annotationRightSelectPanel_ClearBtn).on('click', function () { self.UnSetCurrentAnnotation(); });
        Utilities.GetControl(jqc.annotationRightSelectPanel_MapBtn).on('click', function () { events.bus.publish(events.eventZoomToWKTandHighlight([[self.annotationToolbar_CurrentAnnotationWKT], true, false, FeatureType.Annotation])); });
        Utilities.GetControl(jqc.annotationRightSelectPanel_ListBtn).on('click', function () { self.openEditAnnotationGroupPanel(self.annotationToolbar_CurrentAnnotationUID); });

        // ****************************************************
        // Setup
        self.SetupToolbarBtnActions();
        self.createDragEvents();
        self.createMouseoverEvents();
    }

    // ----------------------------------------------------------- //
    // OPEN PANELS
    public OpenListPanel = (): void => {
        const self = this;

        // rest page
        self.resetPage();

        // Show the page
        Utilities.GetControl(jqc.annotationsPanel).addClass('show');

        // Get data
        self.GetAnnotationData();
    }

    private openEditAnnotationGroupPanel = (UID: number): void => {
        const self = this;
        Utilities.BlockUI();
        Utilities.GetControl(jqc.placeholder_for_modals).load(window.G_SITEFOLDERNAME + '/Annotations/AnnotationEdit', { UID: UID }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            Utilities.GetModal(jqc.annotationEditModal, ModalAction.Create);

            // Open the edit toolbar
            self.SetCurrentAnnotation(UID, Utilities.GetControl(jqc.annotationEditModal + ' [name="Title"]' ).val().toString(), null, false, true);

            $(jqc.annotationEditModal + ' [name="StyleList"').on('change', function () {
                var d: any = $(this).val();
                $(jqc.annotationEditModal + ' [name="Style"').val(d);
            });

            // Get form validation
            Utilities.InitFormValidation(Utilities.GetControl(jqc.annotationEditModal));

            Utilities.GetControl(jqc.annotationEditSubmitBtn).on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = Utilities.GetControl(jqc.annotationEditForm);
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI();
                let formData = new FormData(<any>Utilities.GetControl(jqc.annotationEditForm)[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: '/Annotations/UpdateAnnotation',
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_EditComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });

                                self.GetAnnotationData();
                                events.bus.publish(events.eventRefreshMapLayer(FeatureType.Annotation));
                                Utilities.UnBlockUI();
                                Utilities.GetModal(jqc.annotationEditModal, ModalAction.Hide);
                            }
                            else {
                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_EditFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });

                                //if (result.message == null) toastr.error('Failed to edit annotation!');
                                //else toastr.error(result.message)
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            Utilities.GetControl(jqc.annotationEditCloseBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.annotationEditModal, ModalAction.Hide);
            });

            Utilities.GetControl(jqc.annotationEditCancelBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.annotationEditModal, ModalAction.Hide);
            });
        });
    }

    public openCreateAnnotationGroupPanel = (data: ICAMSKey): void => {
        const self = this;
        if (data == null) data = {};
        Utilities.BlockUI();
        $('#placeholder-for-modals').load(window.G_SITEFOLDERNAME +'/Annotations/AnnotationCreate', data, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();
            Utilities.GetModal(jqc.annotationCreateModal, ModalAction.Create);

            // Get form validation
            Utilities.InitFormValidation(Utilities.GetControl(jqc.annotationEditModal));

            Utilities.GetControl(jqc.annotationCreateSubmitBtn).on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = Utilities.GetControl(jqc.annotationCreateForm);
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI();
                $.post('/Annotations/CreateAnnotation', form.serialize(),
                    function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_CreateComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });

                                Utilities.GetModal(jqc.annotationCreateModal, ModalAction.Hide);
                                self.GetAnnotationData();
                                self.SetCurrentAnnotation(result.uid, result.title, null, false, true);
                            }
                            else {
                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_CreateFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.UnBlockUI();
                        }
                    }
                ).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            Utilities.GetControl(jqc.annotationCreateCloseBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.annotationCreateModal, ModalAction.Hide);
            });

            Utilities.GetControl(jqc.annotationCreateCancelBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.annotationCreateModal, ModalAction.Hide);
            });
        });
    }

    public showAnnotationsForFeature = (data: ICAMSKey, autoShowCreatePanel: boolean): void => {
        const self = this;
        var url = "/Annotations/GetAnnotationsForEntity";
        var query = "{data: " + JSON.stringify(data) + "}";
        Utilities.GetControl(jqc.annotationToolContainer).hide();

        $.post(url, data,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        var annotations: Array<any> = JSON.parse(result.data);
                        if (annotations.length == 0) {
                            if (autoShowCreatePanel == true) {
                                //let promptData: IModalPromptRequest = { title: textPacks[0].value, body: textPacks[1].value, yesBtn: textPacks[2].value, noBtn: textPacks[3].value };
                                ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.Annotation_CreateNewGroup }).then(r => {
                                    if (r.yes == true) {
                                        if (self.subscriptionSingleFeatureSelected) self.subscriptionSingleFeatureSelected();
                                        Utilities.GetControl(jqc.annotationsNewBtn);
                                        self.openCreateAnnotationGroupPanel(data);
                                    }
                                    else {
                                    }
                                }).catch(e => { });
                            }
                            else {
                                toastr.error('Annotations do not exist for this feature!')
                            }
                        }
                        else {
                            self.openSelectListPanel(data);
                        }
                    }
                    else {
                        toastr.error('Failed to check data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    public openSelectListPanel = (data: ICAMSKey): void => {
        const self = this;

        Utilities.BlockUI();
        $('#placeholder-for-modals').load(window.G_SITEFOLDERNAME +'/Annotations/AnnotationSelectList', data, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            Utilities.GetModal(jqc.annotationSelectListModal, ModalAction.Create);

            var table: any = Utilities.GetControl(jqc.annotationsSelectListTable);
            table.bootstrapTable();

            Utilities.GetControl(jqc.annotationSelectListShowBtn).on('click', function (evt) {
                var table: any = Utilities.GetControl(jqc.annotationsSelectListTable);
                let rows = table.bootstrapTable('getSelections');
                if (rows == null || rows.length < 1) {
                    Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_PleaseSelectOneRow" }]).then(m => {
                        if (m.success == true) toastr.error(m.data[0].value);
                        else toastr.error("Please select one row.");
                    });
                    return;
                }

                Utilities.GetModal(jqc.annotationSelectListModal, ModalAction.Hide);
                self.SetCurrentAnnotation(rows[0].UID, rows[0].Title, rows[0].WKT, true, false);
            });

            Utilities.GetControl(jqc.annotationSelectListCreateBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.annotationSelectListModal, ModalAction.Hide);
                if (self.subscriptionSingleFeatureSelected) self.subscriptionSingleFeatureSelected();
                Utilities.GetControl(jqc.annotationsNewBtn);
                self.openCreateAnnotationGroupPanel(data);
            });

            Utilities.GetControl(jqc.annotationSelectListDeleteBtn).on('click', function (evt) {
                var table: any = Utilities.GetControl(jqc.annotationsSelectListTable);
                let rows = table.bootstrapTable('getSelections');
                if (rows == null || rows.length < 1) {
                    Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_PleaseSelectOneRow" }]).then(m => {
                        if (m.success == true) toastr.error(m.data[0].value);
                        else toastr.error("Please select one row.");
                    });
                    return;
                }

                Utilities.GetModal(jqc.annotationSelectListModal, ModalAction.Hide);
                self.DeleteAnnotationFromServer(rows[0].UID as number);
            });

            Utilities.GetControl(jqc.annotationSelectListCloseBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.annotationSelectListModal, ModalAction.Hide);
            });

            Utilities.GetControl(jqc.annotationSelectListCancelBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.annotationSelectListModal, ModalAction.Hide);
            });
        });
    }

    public selectFeatureThenCreateNewAnnotationSet = (): void => {
        const self = this;

        Utilities.GetControl(jqc.annotationToolMainTools).hide();

        if (self.subscriptionSingleFeatureSelected) self.subscriptionSingleFeatureSelected();

        self.subscriptionSingleFeatureSelected = events.bus.subscribe(events.eventSingleFeatureSelected, m => {
            //self.subscriptionSingleFeatureSelected(); DO NOT NEED TO DO THIS HERE. IT IS HANDLED IN OTHER FUNCTIONS
            var key: ICAMSKey = {};
            var feature: Feature = m.payload;
            let props = feature.getProperties();

            if (props.MaintCode != null) {
                key.featureType = FeatureType.Maint;
                key.code = props.MaintCode;
            }
            else if (props.RouteCode != null) {
                key.featureType = FeatureType.Route;
                key.code = props.RouteCode;
            }
            else if (props.InfraCode != null) {
                key.featureType = FeatureType.Infra;
                key.code = props.InfraCode;
            }
            else if (props.LandCode != null) {
                key.featureType = FeatureType.Land;
                key.code = props.LandCode;
            }
            else if (props.TROCode != null) {
                key.featureType = FeatureType.TRO;
                key.code = props.TROCode;
            }

            self.showAnnotationsForFeature(key, true);
        });

        let interactionData: IMapInteractionConfig = { zoomToSelectedFeatures: false, addToExistingSelection: false, selectableLayers: [FeatureType.Maint, FeatureType.Infra, FeatureType.Route, FeatureType.Land, FeatureType.TRO] };
        events.bus.publish(events.eventStartSingleSelection(interactionData));
        Utilities.GetControl(jqc.newAnnotationPanel).addClass('show');
    }

    // ----------------------------------------------------------- //
    // GET DATA FROM SERVER
    private GetAnnotationData = (): void => {
        const self = this;

        // Set the default filter to be all
        let filterVal = AnnotationFilter.All.toString();

        // Apply any filters selected from the drop down
        let viewName = "";
        let filterDef: IFilterDefinitionModel = $(jqc.annotationsRecordFilter).children("option:selected").data('filterdefinition');
        if (filterDef != null) { viewName = filterDef.viewName; }


        let url = "/Annotations/GetAnnotations";
        let query = { data: { ViewName: viewName, Filters: [filterVal], CustomFilters: null, Order: AnnotationOrder.None, Skip: self.currentPage * self.issueMaxNumberInList, Take: self.issueMaxNumberInList } };

        Utilities.BlockUI(Utilities.GetControl(jqc.annotationsListContainer));
        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        var data: Array<any> = JSON.parse(result.data);
                        var table: any = Utilities.GetControl(jqc.annotationsListTable)
                        table.bootstrapTable('load', data)
                        self.updatePagingUI();
                        self.checkVisibleButtons();

                        // Update count
                        var countStr = " (" + result.totalCount + ")";
                        self.issueCountFromServer = result.totalCount;
                        Utilities.GetControl(jqc.annotationsSelectedView_TitleCount).html(countStr);
                    }
                    else {
                        Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_FailedToGetData" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
                finally {
                    Utilities.UnBlockUI(Utilities.GetControl(jqc.annotationsListContainer));
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    private checkVisibleButtons = (): void => {
        const self = this;
        var table: any = Utilities.GetControl(jqc.annotationsListTable)
        let rows = table.bootstrapTable('getSelections');

        // Reset all btns first
        Object.keys(this.actionBtns).forEach(k => {
            self.actionBtns[k].enable = false;
        });

        // Then switch on the ones we want depending on the nde type
        self.actionBtns.new.enable = true;
        if (rows && rows.length == 1) {
            self.actionBtns.edit.enable = true;
            self.actionBtns.delete.enable = true;
            self.actionBtns.print.enable = true;
        }
        else if (rows && rows.length > 1) {

        }

        Object.keys(this.actionBtns).forEach(k => {
            if (self.actionBtns[k].enable == true) self.actionBtns[k].btn.prop("disabled", false);
            else self.actionBtns[k].btn.prop("disabled", true);
        });
    }

    // ----------------------------------------------------------- //
    // CREATE GEOM
    private CreateOrUpdateGeomAtServer = (): void => {
        const self = this;

        // Validate
        let form: any = Utilities.GetControl(jqc.annotationToolCreateWizard_EditForm);
        if (Utilities.CheckFormValidation(form)==false) return;

        Utilities.BlockUI();
        let formData = new FormData(<any>Utilities.GetControl(jqc.annotationToolCreateWizard_EditForm)[0]);
        $.ajax({
            type: "POST",
            processData: false,
            contentType: false,
            enctype: 'multipart/form-data',
            url: '/Annotations/UpdateAnnotationGeomViaView',
            data: formData,
            success: function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_EditComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });
                        events.bus.publish(events.eventModifyFeatureSave(function () {
                            events.bus.publish(events.eventRefreshMapLayer(FeatureType.Annotation));
                            Utilities.UnBlockUI();
                            self.ResetToolbar(true);
                        })); // save the MODIFIED geom at the server (this only fires if the geom was modified)
                        
                    }
                    else {
                        Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_EditFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });

                        //if (result.message == null) toastr.error('Failed to edit annotation!');
                        //else toastr.error(result.message);
                        Utilities.UnBlockUI();
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                    Utilities.UnBlockUI();
                }
            }
        }).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    // ----------------------------------------------------------- //
    // DELETE FROM SERVER
    private DeleteAnnotationFromServer = (UID: number): void => {
        const self = this;

        ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.Delete }).then(r => {
            if (r.yes == true) {
                doDelete();
            }
            else {
            }
        }).catch(e => { });

        function doDelete() {
            let url = "/Annotations/DeleteAnnotation";
            let query = { UID: UID };

            $.post(url, query,
                function (result: IAPIResult) {
                    try {
                        if (result.success == true) {
                            self.GetAnnotationData();
                            events.bus.publish(events.eventRefreshMapLayer(FeatureType.Annotation));
                            self.CloseAnnotationToolbar();
                        }
                        else {
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
                        }
                    }
                    catch (err) {
                        console.log(err);
                        alert(err);
                    }
                }
            ).fail(function (xhr) {
                if (xhr.status === 401) {//redirect to login in unauthorised
                    window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                }
            });
        }
    }

    private DeleteAnnotationGeomFromServer = (UID: number): void => {
        const self = this;
        let url = "/Annotations/DeleteAnnotationGeom";
        let query = { UID: UID };

        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        self.GetAnnotationData();
                        events.bus.publish(events.eventRefreshMapLayer(FeatureType.Annotation));
                        events.bus.publish(events.eventClearAllHighlights());
                        events.bus.publish(events.eventClearSelectedFeatures());
                    }
                    else {
                        Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }


    // ----------------------------------------------------------- //
    // ANNOTATION TOOLBAR 
    public SetCurrentAnnotation = (annotationUID: number, title: string, WKT: string, zoomToAnnotationSet: boolean, openToolbar: boolean): void => {
        // Set the annotation ID
        this.annotationToolbar_CurrentAnnotationUID = annotationUID;
        this.annotationToolbar_CurrentAnnotationWKT = WKT;
        
        // Show the annotation set on the map
        events.bus.publish(events.eventSetVisibleMapLayer([FeatureType.Annotation, true]));
        events.bus.publish(events.eventSetAnnotationFilterUID(annotationUID));

        // Optoinally zoom to it
        if (zoomToAnnotationSet == true && WKT != null) {
            events.bus.publish(events.eventZoomToWKTandHighlight([[WKT], false, false, FeatureType.Annotation]));
        }
        events.bus.publish(events.eventRefreshMapLayer(FeatureType.Annotation));

        // Reset the toolbat and other items
        this.ResetToolbar(openToolbar);
        Utilities.GetControl(jqc.annotationToolTitle).text(title);

        // Open the toolbar if required
        if (openToolbar == true) {
            Utilities.GetControl(jqc.annotationToolContainer).show();
            Utilities.GetControl(jqc.annotationToolMainTools).show();
            Utilities.GetControl(jqc.annotationToolCreateWizard).hide();
            Utilities.GetControl(jqc.annotationRightSelectPanel_EditBtn).css('color', 'lightgreen');
        }
        else {
            Utilities.GetControl(jqc.annotationRightSelectPanel_EditBtn).css('color', 'white');
        }

        // Show the 'annotation right hand panel
        if (Utilities.GetControl(jqc.rightSelectGroupPanel).hasClass('show') == false) Utilities.GetControl(jqc.rightSelectGroupPanel).addClass('show');
        Utilities.GetControl(jqc.annotationRightSelectPanelMessage).html("<b>Annotation: </b>"+title);
        Utilities.GetControl(jqc.annotationRightSelectPanel).show();
    }

    private UnSetCurrentAnnotation = (): void => {
        var self = this;
        self.annotationToolbar_CurrentAnnotationUID = null;
        self.CloseAnnotationToolbar();
        events.bus.publish(events.eventSetAnnotationFilterUID(null));
        events.bus.publish(events.eventRefreshMapLayer(FeatureType.Annotation));
        events.bus.publish(events.eventSetVisibleMapLayer([FeatureType.Annotation, false]));
        Utilities.GetControl(jqc.annotationRightSelectPanel).hide();
        if (Utilities.GetControl(jqc.rightSelectGroupPanel + ' #treeResultsSelectedFeaturesPanel').is(":visible") == false) Utilities.GetControl(jqc.rightSelectGroupPanel).removeClass('show');
    }

    private CloseAnnotationToolbar = (): void => {
        var self = this;
        if (self.subscriptionSingleFeatureSelected != null) self.subscriptionSingleFeatureSelected();
        self.ResetToolbar(false);
        Utilities.GetControl(jqc.annotationToolContainer).hide();
        Utilities.GetControl(jqc.annotationRightSelectPanel_EditBtn).css('color', 'white');
    }

    private EnableToolbarBtn = (btnName: string): void => {
        const self = this;
        // Reset all btns first
        Object.keys(this.toolbarBtns).forEach(k => {
            self.toolbarBtns[k].enable = false;
        });

        if (btnName != null) self.toolbarBtns[btnName].enable = true;

        Object.keys(this.toolbarBtns).forEach(k => {
            if (self.toolbarBtns[k].enable == true) self.toolbarBtns[k].btn.prop("disabled", false);
            else self.toolbarBtns[k].btn.prop("disabled", true);
        });
    }

    private ResetToolbar = (selectActive: Boolean): void => {
        const self = this;
        Object.keys(this.toolbarBtns).forEach(k => {
            self.toolbarBtns[k].btn.prop("disabled", false);
        });

        Utilities.GetControl(jqc.annotationToolMainTools).show();
        Utilities.GetControl(jqc.annotationToolCreateWizard).hide();

        events.bus.publish(events.eventClearAllHighlights());
        events.bus.publish(events.eventClearSelectedFeatures());
        events.bus.publish(events.eventRemoveAllMapInteractions());
        if (self.subscriptionDrawCompleted) self.subscriptionDrawCompleted();
        if (self.subscriptionMapGeometrySaved) self.subscriptionMapGeometrySaved();
        if (self.subscriptionSingleFeatureSelected) self.subscriptionSingleFeatureSelected();
        events.bus.publish(events.eventModifyFeatureCancel());

        // This will automatically start the select process
        if (selectActive == true) {
            self.newAnnotationWizard_SelectStart();
        }
    }

    private SetupToolbarBtnActions = (): void => {
        const self = this;

        // ANNOTATION WIZARD
        Utilities.GetControl(jqc.annotationToolCreateWizard_SaveBtn).on('click', function () {
            // Save styles
            if ($(jqc.annotationToolCreateWizard + ' [name="IsThisANewEntity"]').val() == "True") {
                // Construct the object and then load the create new form
                let wkt = $(jqc.annotationToolCreateWizard_EditForm + ' [name="WKT"]').val();
                if (wkt == null || wkt == "") {
                    let format = new WKT();
                    wkt = format.writeGeometry(self.newAnnotationWizardState.drawFeature.getGeometry());
                    $(jqc.annotationToolCreateWizard_EditForm + ' [name="WKT"]').val(wkt);
                }
                var style = self.getLocalStyleDetails(); var val;
                val = $(jqc.annotationToolCreateWizard + ' [name="styleModel.text.fillColorHex"]').val(); if (val != null) style.text.fillColorHex = val;
                val = $(jqc.annotationToolCreateWizard + ' [name="styleModel.text.size"]').val(); if (val != null) style.text.size = val;
                val = $(jqc.annotationToolCreateWizard + ' [name="styleModel.text.weight"]').val(); if (val != null) style.text.weight = val;
                val = $(jqc.annotationToolCreateWizard + ' [name="styleModel.text.font"]').val(); if (val != null) style.text.font = val;

                val = $(jqc.annotationToolCreateWizard + ' [name="styleModel.stroke.colorHex"]').val(); if (val != null) style.stroke.colorHex = val;
                val = $(jqc.annotationToolCreateWizard + ' [name="styleModel.stroke.width"]').val(); if (val != null) style.stroke.width = val;
                val = $(jqc.annotationToolCreateWizard + ' [name="styleModel.stroke.endCap"]').val(); if (val != null) style.stroke.endCap = val;

                val = $(jqc.annotationToolCreateWizard + ' [name="styleModel.fill.colorHex"]').val(); if (val != null) style.fill.colorHex = val;
                self.setLocalStyleDetails(style);
            }

            // Update at the server
            self.CreateOrUpdateGeomAtServer();
        });

        Utilities.GetControl(jqc.annotationToolCreateWizard_CancelBtn).on('click', function () {
            self.ResetToolbar(true);
        }); 

        Utilities.GetControl(jqc.annotationToolCreateWizard_DeleteBtn).on('click', function () {
            self.deleteGeometryEventStart(self.newAnnotationWizardState.selectedFeature_AnnotationGeomID);
            self.ResetToolbar(true);
        });

        // SELECT 
        Utilities.GetControl(jqc.annotationsToolCreateSelectBtn).on('click', function () {
            self.EnableToolbarBtn('select');
            self.annotationToolbar_CreateType = 'select';
            events.bus.publish(events.eventRemoveAllMapInteractions());
            self.newAnnotationWizard_SelectStart();
        });

        // CREATE 
        Utilities.GetControl(jqc.annotationsToolCreateTextBtn).on('click', function () {
            self.EnableToolbarBtn('createtext');
            self.annotationToolbar_CreateType = 'createtext';
            self.newAnnotationWizard_Start();
        });

        Utilities.GetControl(jqc.annotationsToolCreatePointBtn).on('click', function () {
            self.EnableToolbarBtn('createpoint');
            self.annotationToolbar_CreateType = 'createpoint';
            self.newAnnotationWizard_Start();
        });

        Utilities.GetControl(jqc.annotationsToolCreateLineBtn).on('click', function () {
            self.EnableToolbarBtn('createline');
            self.annotationToolbar_CreateType = 'createline';
            self.newAnnotationWizard_Start();
        });

        Utilities.GetControl(jqc.annotationsToolCreatePolygonBtn).on('click', function () {
            self.EnableToolbarBtn('createpoly');
            self.annotationToolbar_CreateType = 'createpoly';
            self.newAnnotationWizard_Start();
        });

        Utilities.GetControl(jqc.annotationsToolCreateRectangleBtn).on('click', function () {
            self.EnableToolbarBtn('createrect');
            self.annotationToolbar_CreateType = 'createrect';
            self.newAnnotationWizard_Start();
        });
    }

    private newAnnotationWizard_SelectStart = (): void => {
        const self = this;

        //Utilities.GetControl(jqc.annotationToolCreateWizard_SelectMessage1).show();
        $(jqc.annotationsToolCreateSelectBtn + ' button').css('color', 'lightgreen');
        $(jqc.annotationsToolCreateSelectBtn + ' button').addClass('active');
        $(jqc.annotationsToolCreateSelectBtn + ' button').addClass('focus');
        Utilities.GetControl(jqc.annotationToolCreateWizard_SelectMessage2).hide();
        Utilities.GetControl(jqc.annotationToolCreateWizard_Message1).hide();
        Utilities.GetControl(jqc.annotationToolCreateWizard_Message2).hide();
        //Utilities.GetControl(jqc.annotationToolMainTools).hide();
        Utilities.GetControl(jqc.annotationToolCreateWizard_SaveBtn).hide;
        Utilities.GetControl(jqc.annotationToolCreateWizard_DeleteBtn).hide();
        events.bus.publish(events.eventClearSelectedFeatures());

        if (self.subscriptionDrawCompleted) self.subscriptionDrawCompleted();
        if (self.subscriptionMapGeometrySaved) self.subscriptionMapGeometrySaved();
        if (self.subscriptionSingleFeatureSelected) self.subscriptionSingleFeatureSelected();

        this.newAnnotationWizardState = {};

        self.subscriptionSingleFeatureSelected = events.bus.subscribe(events.eventSingleFeatureSelected, m => {
            // Unsubscribe the select interaction
            self.subscriptionSingleFeatureSelected();

            // Fire off the modify interaction
            let props = m.payload.getProperties();
            self.editTextEventStart(props.AnnotationGeomID);
            self.editGeometryEventStart(props.AnnotationGeomID);
            
            // Start the select interaction once again, this allows the user to select other features
            self.newAnnotationWizard_SelectStart();
            self.newAnnotationWizardState = { selectedFeature_AnnotationGeomID: props.AnnotationGeomID };

            // Show the relevant pabnels
            Utilities.GetControl(jqc.annotationToolMainTools).hide();
            Utilities.GetControl(jqc.annotationToolCreateWizard).show();
            Utilities.GetControl(jqc.annotationToolCreateWizard_SelectMessage1).hide();
            Utilities.GetControl(jqc.annotationToolCreateWizard_SelectMessage2).show();
            Utilities.GetControl(jqc.annotationToolCreateWizard_Message2).show();
            Utilities.GetControl(jqc.annotationToolCreateWizard_SaveBtn).show();
            Utilities.GetControl(jqc.annotationToolCreateWizard_DeleteBtn).show();

        });

        let interactionData: IMapInteractionConfig = { zoomToSelectedFeatures: false, addToExistingSelection: false, selectableLayers: [FeatureType.Annotation], resetAllInteractions: false };
        events.bus.publish(events.eventStartSingleSelection(interactionData))
    }

    private newAnnotationWizard_Start = (): void => {
        const self = this;

        var geomType = GeometryType.POINT; var geomTypeStr = "Text";
        if (self.annotationToolbar_CreateType == "createline") { geomType = GeometryType.LINE_STRING; geomTypeStr = "Line"; }
        else if (self.annotationToolbar_CreateType == "createpoly") { geomType = GeometryType.POLYGON; geomTypeStr = "Poly"; }
        else if (self.annotationToolbar_CreateType == "createrect") { geomType = GeometryType.CIRCLE; geomTypeStr = "Poly"; }

        Utilities.GetControl(jqc.annotationToolCreateWizard_SelectMessage1).hide();
        Utilities.GetControl(jqc.annotationToolCreateWizard_SelectMessage2).hide();
        Utilities.GetControl(jqc.annotationToolCreateWizard_DeleteBtn).hide();
        Utilities.GetControl(jqc.annotationToolCreateWizard_Message1).show();
        Utilities.GetControl(jqc.annotationToolCreateWizard_Message2).show();
        Utilities.GetControl(jqc.annotationToolMainTools).hide();
        Utilities.GetControl(jqc.annotationToolCreateWizard_SaveBtn).hide();
        Utilities.GetControl(jqc.annotationToolCreateWizard).show();
        events.bus.publish(events.eventClearSelectedFeatures());

        // Load the geom panel
        self.loadAnnotationGeomEditPanel(null, geomTypeStr);

        if (self.subscriptionDrawCompleted) self.subscriptionDrawCompleted();
        if (self.subscriptionMapGeometrySaved) self.subscriptionMapGeometrySaved();
        if (self.subscriptionSingleFeatureSelected) self.subscriptionSingleFeatureSelected();

        this.newAnnotationWizardState = {};

        self.subscriptionDrawCompleted = events.bus.subscribe(events.eventDrawCompelted, m => {
            self.newAnnotationWizardState.drawFeature = m.payload;
            self.subscriptionDrawCompleted();
            Utilities.GetControl(jqc.annotationToolCreateWizard_SaveBtn).show();
            setTimeout(function () { events.bus.publish(events.eventRemoveAllMapInteractions()); }, 100); // Timeout to prevent a double click zoom in event
        });

        events.bus.publish(events.eventStartDrawSelection([geomType, null, null, null, null]));
    }

    private newMaintWizard_Close = (): void => {
        const self = this;
        events.bus.publish(events.eventResetAllPanels());
        events.bus.publish(events.eventRemoveAllMapInteractions());
        events.bus.publish(events.eventResetAllButtons(true));
        events.bus.publish(events.eventClearAllHighlights());
        events.bus.publish(events.eventClearSelectedFeatures());
        if (self.subscriptionDrawCompleted) self.subscriptionDrawCompleted();
        if (self.subscriptionMapGeometrySaved) self.subscriptionMapGeometrySaved();
        if (self.subscriptionSingleFeatureSelected) self.subscriptionSingleFeatureSelected();
    }

    // DRAG EVENTS
    private createDragEvents = (): void => {
        var obj = { startPositionX: 0, startPositionY: 0 }; //mouse position
        var scale = 1.0;
        var translate = { x: 0, y: 0 }; //element relative position
        Utilities.GetControl(jqc.annotationToolTopBar).on("mousedown", function (e) {
            var move = Utilities.GetControl(jqc.annotationToolPanel);
            obj.startPositionX = e.pageX - translate.x;
            obj.startPositionY = e.pageY - translate.y;
            $(document).on("mousemove", function (e) {
                translate.x = e.pageX - obj.startPositionX;
                translate.y = e.pageY - obj.startPositionY;
                move.css({
                    "transform": "translate(" + translate.x + "px," + translate.y + "px)",
                    "transition": "0s"
                });
            });
        });
        $(document).on("mouseup", function () {
            $(this).off("mousemove");
        });

    }

    private createMouseoverEvents = (): void => {
        //Utilities.GetControl(jqc.annotationToolPanel).on("mouseover", function (e) {
        //    $(this).css('opacity', '1');
        //});

        //Utilities.GetControl(jqc.annotationToolPanel).on("mouseout", function (e) {
        //    $(this).css('opacity', '0.7');
        //});
    }

    public editGeometryEventStart = (annotationGeomID: number): void => {
        const self = this;
        let data: ICAMSKey = { code: annotationGeomID.toString(), featureType: FeatureType.Annotation };
        events.bus.publish(events.eventModifyFeature([data, false]));
    }

    public editTextEventStart = (annotationGeomID: number): void => {
        const self = this;
        self.loadAnnotationGeomEditPanel(annotationGeomID, null);
    }

    public deleteGeometryEventStart = (annotationGeomID: number): void => {
        const self = this;
        self.DeleteAnnotationGeomFromServer(annotationGeomID);
    }

    private loadAnnotationGeomEditPanel = (annotationGeomID: number, geomType: string): void => {
        const self = this;
        let query = { annotationGeomID: annotationGeomID, annotationUID: this.annotationToolbar_CurrentAnnotationUID, annotationGeomType: geomType };
        Utilities.BlockUI(Utilities.GetControl(jqc.annotationToolPanel));
        Utilities.GetControl(jqc.annotationToolCreateWizard_Message2).load(window.G_SITEFOLDERNAME + '/Annotations/AnnotationEditGeom', query, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }

            Utilities.UnBlockUI(Utilities.GetControl(jqc.annotationToolPanel));

            // Override the style with the local settings if this is a new entity
            if ($(jqc.annotationToolCreateWizard + ' [name="IsThisANewEntity"]').val() == "True") {
                var style = self.getLocalStyleDetails();

                $(jqc.annotationToolCreateWizard + ' [name="styleModel.text.fillColorHex"]').val(style.text.fillColorHex);
                $(jqc.annotationToolCreateWizard + ' [name="styleModel.text.size"]').val(style.text.size);
                $(jqc.annotationToolCreateWizard + ' [name="styleModel.text.weight"]').val(style.text.weight);
                $(jqc.annotationToolCreateWizard + ' [name="styleModel.text.font"]').val(style.text.font);

                $(jqc.annotationToolCreateWizard + ' [name="styleModel.stroke.colorHex"]').val(style.stroke.colorHex);
                $(jqc.annotationToolCreateWizard + ' [name="styleModel.stroke.width"]').val(style.stroke.width);
                $(jqc.annotationToolCreateWizard + ' [name="styleModel.stroke.endCap"]').val(style.stroke.endCap);

                $(jqc.annotationToolCreateWizard + ' [name="styleModel.fill.colorHex"]').val(style.fill.colorHex);
            }
        });
    }

    // ----------------------------------------------------------- //
    // MISC
    private updatePagingUI = (): void => {
        const self = this;
        if (self.issueCountFromServer > 0) { Utilities.GetControl(jqc.annotationsSelectedView_TitleCount).html(' (' + self.issueCountFromServer + ')'); } else { Utilities.GetControl(jqc.annotationsSelectedView_TitleCount).html(); }
        Utilities.GetControl(jqc.annotationsListShowing).html((self.currentPage + 1).toString());
    }

    private resetPage = (): void => {
        // Reset the page
        this.currentPage = 0;
        this.issueCountFromServer = 0;
        this.updatePagingUI();
    }

    private setupAnnotationListFilters = (): void => {
        const self = this;

        let annotationFilters: Array<IFilterDefinitionModel> = $(jqc.annotationsListContainer + ' [data-annotationfilters]').data('annotationfilters');
        if (annotationFilters != null) {
            annotationFilters.forEach(f => {
                $(jqc.annotationsRecordFilter).append($("<option></option>").attr("data-filterdefinition", JSON.stringify(f)).text(f.label));
            });
        }
    }

    public removeMapInteractions = (): void => {
        const self = this;
        if (self.subscriptionDrawCompleted) self.subscriptionDrawCompleted();
        if (self.subscriptionMapGeometrySaved) self.subscriptionMapGeometrySaved();
        if (self.subscriptionSingleFeatureSelected) self.subscriptionSingleFeatureSelected();
    }

    private getLocalStyleDetails = (): IAnnotationStyleModel => {
        let localStorageSettings_str = window.localStorage.getItem('localStorageSettings');
        let localStorageSettings: LocalStorageSettingsModel = JSON.parse(localStorageSettings_str);
        return localStorageSettings.AnnotationStyle;
    }

    private setLocalStyleDetails = (style: IAnnotationStyleModel): void => {
        let localStorageSettings_str = window.localStorage.getItem('localStorageSettings');
        let localStorageSettings: LocalStorageSettingsModel = JSON.parse(localStorageSettings_str);

        localStorageSettings.AnnotationStyle = style;
        window.localStorage.setItem('localStorageSettings', JSON.stringify(localStorageSettings));
        return;
    }
}
    




